export class InvoiceBanksBonds {
    id: number;
    amount: number;
    bondId: number;
    bondNumber: string;
    dateAp: Date | string;
    datePayPeriodEnd: Date | string;
    datePayPeriodStart: Date | string;
}
